import React from 'react';
import {
  DialogContent as MuiDialogContent,
  DialogContentProps as MuiDialogContentProps,
  useMediaQuery,
  useTheme,
} from '@mui/material';

type DialogContentProps = MuiDialogContentProps & {
  children?: any;
};

export const DialogContent = ({ children = null, sx, ...rest }: DialogContentProps) => {
  const theme = useTheme();
  const down_sm = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <MuiDialogContent
      sx={{
        paddingX: down_sm ? 3 : 8,
        ...sx,
      }}
      {...rest}
    >
      {children}
    </MuiDialogContent>
  );
};
